module.exports = __webpack_public_path__ + "static/favicon-6bd879422376d0126b9b5ade5b777eb6.ico";